export default __webpack_public_path__ + "static/media/facebook.4f0a400f.svg";